export enum MeasureExchangeSurnameID {
  Ministero = '1',
  Prefettura = '2',
}
